import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addCommas,
    addFromColumn,
    parsePercent,
    sortCurrency,
    sortNumber,
    toCurrency
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {convertStartAndEndDatesForFile} from '../shared/printFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/action/assessment';

/**
 * Class for displaying Categories Purchased Summary in a table
 *
 */
class CategoriesPurchasedTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Category', key: 'category_name'},
                {label: 'Qty Sold', key: 'qty_sold'},
                {label: 'Qty Returned', key: 'qty_returned'},
                {label: 'Net Qty', key: 'qty_net'},
                {label: '$ Sold', key: 'subtotal_sold'},
                {label: '$ Returned', key: 'subtotal_returned'},
                {label: '$ Net Total', key: 'net_total'},
                {label: 'Net Percentage', key: 'percent'}
            ],
        };
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: nextProps.listData,
                summaryTableData: nextProps.listData
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /**
     * Set data for use by table
     *
     * @param listData
     */
    processData(listData) {
        this.setState({
            summaryList: listData,
            summaryTableData: listData
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Update selected table data based on filter and lift state
     *
     * @param event
     * @param table
     */
    handleFilterChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    render() {

        const {
            endDate,
            startDate,
            system,
            tableFilename,
            tableKey,
            tableLabel
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartAndEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('category_name');

        // Headers and columns for ReactTable
        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: () => (<span>Category</span>),
                        accessor: 'category_name'
                    },
                    {
                        Header: () => (<span>Qty<br/>Sold</span>),
                        accessor: 'qty_sold',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'qty_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Qty<br/>Returned</span>),
                        accessor: 'qty_returned',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'qty_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Net</span>),
                        accessor: 'qty_net',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'qty_net'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Subtotal<br/>$ Sold</span>),
                        accessor: 'subtotal_sold',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'subtotal_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Total<br/>$ Returned</span>),
                        accessor: 'subtotal_returned',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'subtotal_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Net<br/>Total</span>),
                        accessor: 'net_total',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'net_total'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Percentage',
                        accessor: 'percent',
                        sortMethod: (a, b) => sortNumber(parsePercent(a), parsePercent(b)),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.tdMax}
                    }
                ]
            }
        ];

        return (
            <div>
                <div className="reports-table-container">

                    {/* Table Header */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Button */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={`${tableFilename}-${system}-${dateString}.csv`}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export {tableLabel}
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>{tableLabel}</span>
                        </h3>
                    </div>

                    {/* Tables: Display and Print */}
                    <ReactTable
                        key={`table-${tableFilename}-${tableKey}`}
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortChange(e, this.categoriesReactTable)}
                        onFilteredChange={(e) => this.handleFilterChange(e, this.categoriesReactTable)}
                        ref={(r) => this.categoriesReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key={`table-${tableFilename}-print-${tableKey}`}
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
            </div>
        )
    }
}

CategoriesPurchasedTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    listData: PropTypes.array,
    startDate: PropTypes.string,
    system: PropTypes.string,
    tableFilename: PropTypes.string,
    tableKey: PropTypes.string,
    tableLabel: PropTypes.string
};

CategoriesPurchasedTable.defaultProps = {
    addField: true,
    endDate: null,
    startDate: null,
    tableFilename: 'Categories',
    tableKey: 'categories',
    tableLabel: 'Categories Purchased'
};

export default CategoriesPurchasedTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/CategoriesPurchasedTable.js